'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    store: _store2.default,
    data: function data() {
        return {
            updatesVisible: false,
            data: []
        };
    },

    props: ['getSiteUpdateUrl', 'postSiteUpdateUrl', 'assessmentId', 'titleMain', 'titleEstimation', 'titleCategory', 'titleRiskLevel'],
    computed: _extends({}, (0, _vuex.mapGetters)(['getSiteUpdates', 'getAssessmentId'])),
    mounted: function mounted() {
        var urlPayload = {
            getSiteUpdateUrl: this.getSiteUpdateUrl,
            postSiteUpdateUrl: this.postSiteUpdateUrl
        };
        this.setUrls(urlPayload);
        this.setAssessmentId(this.assessmentId);
    },

    methods: _extends({}, (0, _vuex.mapActions)(['loadSiteUpdates', 'setUrls', 'setAssessmentId']), {
        showUpdates: function showUpdates() {
            this.loadSiteUpdates();
            this.updatesVisible = true;
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/improvements.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/improvements.vue
// module chunks = 0